import { keys, map, sortBy } from 'lodash';
import pluralize from 'pluralize';
import React from 'react';

import { MultiplexMarkersChip } from 'components/atoms/MultiplexMarkersChip';
import { ThresholdJob } from 'interfaces/job';

type JobWithThresholdResults = Pick<ThresholdJob, 'results'>;

export const getThresholdJobMarkerIds = (job?: JobWithThresholdResults): string[] =>
  sortBy(keys(job?.results?.perMarkerThresholds || {}));

export const ThresholdJobMarkersChip = ({ job }: { job?: JobWithThresholdResults }) => {
  const markerIds = getThresholdJobMarkerIds(job);

  return (
    <MultiplexMarkersChip
      appearance="table"
      popoverTitle="Thresholded markers"
      chipLabel={`${markerIds.length} ${pluralize('marker', markerIds.length)}`}
      markerInfos={map(markerIds, (markerId) => ({
        key: markerId,
        markerId,
        label: markerId,
      }))}
    />
  );
};
